/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: {
      value: 1,
    },
    stt: "",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: "",
      bg: true
    },
    title: {
      value: "Kết quả kinh doanh ghi nhận theo báo cáo tài chính",
    },
  },
  {
    id: {
      value: 2,
    },
    stt: "I",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: "",
      bg: true
    },
    title: {
      value: "Doanh thu hoạt động"
  },
  },
  {
    id: {
      value: 3,
    },
    stt: "1.1",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "1",
    value2: {
      value: 0,
      bg: false

    },
    title: {
      value: "Lãi từ các tài sản tài chính ghi nhận thông qua lãi / lỗ (FVTPL)",
    },
  },
  {
    id: {
      value: 4,
    },
    stt: "a",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "01.1",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lãi bán các tài sản tài chính FVTPL",
    },
  },
  {
    id: {
      value: 5,
    },
    stt: "b",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "01.2",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chênh lệch tăng về đánh giá lại các TSTC FVTPL",
    },
  },
  {
    id: {
      value: 6,
    },
    stt: "c",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "01.3",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Cổ tức, tiền lãi phát sinh từ tài sản tài chính FVTPL",
    },
  },
  {
    id: {
      value: 7,
    },
    stt: "1.2",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "2",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lãi từ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    },
  },
  {
    id: {
      value: 8,
    },
    stt: "1.3",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "3",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lãi từ các khoản cho vay và lãi thu",
    },
  },
  {
    id: {
      value: 9,
    },
    stt: "1.4",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "4",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lãi từ tài sản tài chính sẳn sàng để bán (AFS)",
    },
  },
  {
    id: {
      value: 10,
    },
    stt: "1.5",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "5",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lãi từ các công cụ phát sinh phòng ngừa rủi ro",
    },
  },
  {
    id: {
      value: 11,
    },
    stt: "1.6",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "6",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu nghiệp vụ môi giới chứng khoán",
    },
  },
  {
    id: {
      value: 12,
    },
    stt: "1.7",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "7",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu nghiệp vụ bảo lãnh, đại lý phát hành chứng khoán",
    },
  },
  {
    id: {
      value: 13,
    },
    stt: "1.8",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "8",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu nghiệp vụ tư vấn đầu tư chứng khoán",
    },
  },
  {
    id: {
      value: 14,
    },
    stt: "1.9",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "9",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu nghiệp vụ lưu ký chứng khoán",
    },
  },
  {
    id: {
      value: 15,
    },
    stt: "1.10",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "10",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu hoạt động tư vấn tài chính",
    },
  },
  {
    id: {
      value: 16,
    },
    stt: "1.11",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "11",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Thu nhập hoạt động khác",
    },
  },
  {
    id: {
      value: 17,
    },
    stt: "",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "20",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Cộng doanh thu hoạt động (20 = 1 -> 11)",
    },
  },
  {
    id: {
      value: 18,
    },
    stt: "II",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: "",
      bg: true
    },
    title: {
      value: "Chi phí hoạt động",
    },
  },
  {
    id: {
      value: 19,
    },
    stt: "2.1",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "21",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lỗ các tài sản tài chính ghi nhận thông qua lãi/ lỗ (FVTPL)",
    },
  },
  {
    id: {
      value: 20,
    },
    stt: "a",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "21.1",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lỗ bán các tài sản tài chính FVTPL",
    },
  },
  {
    id: {
      value: 21,
    },
    stt: "b",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "21.2",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chênh lệch giảm đánh giá lại các TSTC FVTPL",
    },
  },
  {
    id: {
      value: 22,
    },
    stt: "c",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "21.3",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí giao dịch mua các tài sản tài chính FVTPL",
    },
  },
  {
    id: {
      value: 23,
    },
    stt: 2.2,
    bg: false,
    bold: false,
    ilalic: false,
    value1: "22",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lỗ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    },
  },
  {
    id: {
      value: 24,
    },
    stt: "2.3",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "23",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lỗ và ghi nhận chênh lệch đánh giá theo giá trị hợp lý tài sản tài chính sẳn sàng để bán (AFS) khi phân loại lại",
    },
  },
  {
    id: {
      value: 25,
    },
    stt: "2.4",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "24",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí dự phòng tài sản tài chính, xử lý tổn thất các khoản phải thu khó đòi và lỗ suy giảm tài sản tài chính và chi phí đi vay của các khoản cho vay",
    },
  },
  {
    id: {
      value: 26,
    },
    stt: "2.5",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "25",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lỗ từ các tài sản tài chính phát sinh phòng ngừa rủi ro",
    },
  },
  {
    id: {
      value: 27,
    },
    stt: "2.6",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "26",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí hoạt động tự doanh",
    },
  },
  {
    id: {
      value: 28,
    },
    stt: "2.7",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "27",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí nghiệp vụ môi giới chứng khoán",
    },
  },
  {
    id: {
      value: 29,
    },
    stt: "2.8",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "28",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí nghiệp vụ bảo lãnh, đại lý phát hành chứng khoán",
    },
  },
  {
    id: {
      value: 30,
    },
    stt: "2.9",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "29",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí nghiệp vụ tư vấn đầu tư chứng khoán",
    },
  },
  {
    id: {
      value: 31,
    },
    stt: "2.10",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "30",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí nghiệp vụ lưu ký chứng khoán",
    },
  },
  {
    id: {
      value: "32",
    },
    stt: "2.11",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "31",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí hoạt động tư vấn tài chính",
    },
  },
  {
    id: {
      value: 33,
    },
    stt: "2.12",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "32",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí các dịch vụ khác",
    },
  },
  {
    id: {
      value: 34,
    },
    stt: "",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "40",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Cộng chi phí hoạt động (40 = 21 -> 32)",
    },
  },
  {
    id: {
      value: 35,
    },
    stt: "III",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: "",
      bg: true
    },
    title: {
      value: "Doanh thu hoạt động tài chính",
    },
  },
  {
    id: {
      value: 36,
    },
    stt: "3.1",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "41",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chênh lệch lãi tỷ giá hối đoái đã và chưa thực hiện",
    },
  },
  {
    id: {
      value: 37,
    },
    stt: "3.2",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "42",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu, dự thu cổ tức, lãi tiền gửi ngân hàng không cố định",
    },
  },
  {
    id: {
      value: 38,
    },
    stt: "3.3",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "43",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lãi bán, thanh toán các khoản đầu tư vào công ty con, liên kết, liên doanh",
    },
  },
  {
    id: {
      value: 39,
    },
    stt: "3.4",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "44",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Doanh thu khác về đầu tư",
    },
  },
  {
    id: {
      value: 40,
    },
    stt: "",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "50",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Cộng chi phí tài chính (50 = 41 -> 44)",
    },
  },
  {
    id: {
      value: 41,
    },
    stt: "IV",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: "",
      bg: true
    },
    title: {
      value: "Chi phí tài chính",
    },
  },
  {
    id: {
      value: 42,
    },
    stt: "4.1",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "51",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chênh lệch lỗ tỷ giá hối đoái đã và chưa thực hiện",
    },
  },
  {
    id: {
      value: 43,
    },
    stt: "4.2",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "52",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí lãi vay",
    },
  },
  {
    id: {
      value: 44,
    },
    stt: "4.3",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "53",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Lỗ bán, thanh toán các khoản đầu tư vào công ty con, liên kết, liên doanh",
    },
  },
  {
    id: {
      value: 45,
    },
    stt: "4.4",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "54",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí dự phòng suy giảm giá trị các khoản đầu tư tài chính dài hạn",
    },
  },
  {
    id: {
      value: 46,
    },
    stt: "4.5",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "55",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí tài chính khác",
    },
  },
  {
    id: {
      value: 47,
    },
    stt: "",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "60",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Cộng chi phí tài chính (60 = 51 -> 55)",
    },
  },
  {
    id: {
      value: 48,
    },
    stt: "V",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "61",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí bán hàng",
    },
  },
  {
    id: {
      value: 49,
    },
    stt: "VI",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí quản lý công ty",
    },
  },
  {
    id: {
      value: 50,
    },
    stt: "VII",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "70",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Kết quả hoạt động (70 = 20 + 50 - 40 - 60 - 61 - 62)",
    },
  },
  {
    id: {
      value: 51,
    },
    stt: "VIII",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: ""
      ,
      bg: true
    },
    title: {
      value: "Thu nhập khác và chi phí khác",
    },
  },
  {
    id: {
      value: 52,
    },
    stt: "8.1",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "71",
    value2: {
      value: 0
      ,
      bg: false
    },
    title: {
      value: "Thu nhập khác",
    },
  },
  {
    id: {
      value: 53,
    },
    stt: "8.2",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "72",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Chi phí khác",
    },
  },
  {
    id: {
      value: 54,
    },
    stt: "",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "80",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Cộng kết quả hoạt động khác (80 = 71 - 72)",
    },
  },
  {
    id: {
      value: 55,
    },
    stt: "IX",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "90",
    value2: {
      value: 0,
      bg: false
    },
    title: {
      value: "Tổng lợi nhuận kế toán trước thuế (90 = 70 + 80)",
    },
  },
];

export default function Table4({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
        <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center"}}>
                (1)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (2)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (3)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (4)
              </Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.stt}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.title.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.value1}
                  </Td>

                  <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.bg ? "transparent" : "#ddeff3",
                          fontWeight: !row.bold ? "normal" : "bold",
                          fontStyle: !row.ilalic ? "normal" : "italic"
                        }}
                      >
                        {row.value2.bg == true ? (
                          row.value2.value
                        ) : (
                          <InputTable
                            id={row.id.value}
                            name="value2"
                            value={row.value2.value}
                            onChange={handleChange}
                            isBold = {row.bold}
                          />
                        )}
                      </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, isBold, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: isBold ? "bold" : "normal"
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
